const companies = [
    'sber-logo.svg',
    'yandex-market-logo.svg',
    'yandex-eda-logo.svg',
    'yandex-go-logo.svg',
    'whoosh-logo.svg',
    'samokat-logo.svg',
] as const;

export default companies;
